import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-failed-rounded"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"44\" height=\"44\" class=\"icon-fi--no-fill icon-fi--filled\"></rect><g transform=\"translate(53 -2115)\" class=\"\"><g transform=\"translate(-41 2127)\" class=\"\"><circle cx=\"10\" cy=\"10\" r=\"10\" class=\"icon-fi--no-fill\"></circle><circle cx=\"10\" cy=\"10\" r=\"9.4\" class=\"icon-fi--no-fill icon-fi--with-stroke\"></circle></g><line x1=\"-35\" x2=\"-27\" y1=\"2141\" y2=\"2133\" class=\"icon-fi--no-fill icon-fi--with-stroke\"></line><line x1=\"-27\" x2=\"-35\" y1=\"2141\" y2=\"2133\" class=\"icon-fi--no-fill icon-fi--with-stroke\"></line></g>", 2)
  ]), 16))
}
export default { render: render }